import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { i as inheritAriaAttributes, c as clsx } from './p-50b8bf73.js';
import { n as nanoid } from './p-5959f2bd.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconChevronDownStyle0 = stylesCss;

const BiIconChevronDown = /*@__PURE__*/ proxyCustomElement(class BiIconChevronDown extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: 'f15609f97861291ba7e7f2288ba794edacf4711e', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '094348aa8aa20eaa7b02431af11d79823737fb23', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: '4bdddef05443d211f4a7c93d08424e0139f9e559', "fill-rule": 'evenodd', d: 'm6.342 9.848 1.06-1.06 5.461 5.46 5.461-5.46 1.061 1.06-6.522 6.522z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconChevronDownStyle0; }
}, [1, "bi-icon-chevron-down", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-chevron-down"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-chevron-down":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconChevronDown);
            }
            break;
    } });
}

export { BiIconChevronDown as B, defineCustomElement as d };
